import {createApp} from 'vue'
import Store from 'store'
import options from './ProductDetailBar.options'

import {dataLayerViewProductDetails} from '../../foundation/js/dataLayerHelpers'



// Note: We are only making a component out of the small area showing the price.
// The reason for this is that we need to switch between two prices (normal or msrp) without
// changing too much of the already existing markup. Normally we would have created a component
// out of the entire block.
const el = '.nlx-component--product-detail-price'
const DOM = document.querySelector(el)

if(DOM){
    const template = DOM.innerHTML
    const priceDOM = DOM.querySelector('.nlx-js--pdp-price')
    const msrp = priceDOM.dataset.msrp
    const price = priceDOM.innerText
    const taxDOM = DOM.querySelector('.nlx-js--pdp-tax')
    const msrpTax = taxDOM.dataset.msrpTax
    const tax = taxDOM.innerText

    options.template = template

    const component = createApp(options,{
        prices: {
            msrp,
            price
        },
        tax: {
          msrpTax,
          tax
        }
    }).use(Store)
    component.mount(el)
    dataLayerViewProductDetails()
}

